module.exports = __webpack_public_path__ + "img/ticket-transaccion.8f19b99b.jpg";